import { render, staticRenderFns } from "./buyerLogout.vue?vue&type=template&id=199f4ee8&scoped=true&"
import script from "./buyerLogout.vue?vue&type=script&lang=js&"
export * from "./buyerLogout.vue?vue&type=script&lang=js&"
import style0 from "./buyerLogout.vue?vue&type=style&index=0&id=199f4ee8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199f4ee8",
  null
  
)

export default component.exports